import React from 'react';
import { Stack } from '@moda/om';
import { useFeatureFlag, FulfillmentTypes, Availability } from '@moda/portal-stanchions';
import {
  ProductDetailsFragment,
  ProductDetailsVariantFragment,
  SizeInventoryFragment
} from '../../../generated/types';
import { useInEurope } from '../../../hooks/useInEurope';
import { AddToBagButton } from '../../AddToBagButton';
import { PdpDeliveryInfo } from '../../PdpInfoContainer/PdpDeliveryInfo';
import { ProductDetailsFavoriteSection } from '../ProductDetailsFavoriteSection';
import { ProductDetailsFinalSaleInformation } from '../ProductDetailsFinalSaleInformation';

interface Props {
  variant: ProductDetailsFragment;
  activeVariant: ProductDetailsVariantFragment;
  size: SizeInventoryFragment | null;
  quantity?: number;
  customizationMessage: string;
  isCustomizationValid: boolean;
  selectedSize: SizeInventoryFragment | null;
}

export const ProductDetailsCallToActionSection: React.FC<Props> = ({
  variant,
  activeVariant,
  size,
  quantity,
  customizationMessage,
  isCustomizationValid,
  selectedSize
}) => {
  const favoritesButton = useFeatureFlag('favorites', [
    { default: 'button' },
    { if: 'icon', then: 'icon' }
  ]);

  const inEurope = useInEurope();

  const showDeliveryWindow =
    size?.canSell &&
    variant.availability === String(Availability.Preorder) &&
    variant.fulfilmentType !== FulfillmentTypes.DropShip &&
    variant.fulfilmentType !== FulfillmentTypes.Fulfillment &&
    variant.fulfilmentType !== FulfillmentTypes.MiraklDropship;

  if (size && !size.canSell) {
    return null;
  }

  return (
    <Stack space={3} className="ProductDetailsCallToActionSection">
      {variant.available && (
        <AddToBagButton
          activeVariantId={activeVariant.id}
          customization={customizationMessage}
          isCustomizationValid={isCustomizationValid}
          size={size}
          quantity={quantity}
          validatesSizePresenceOn="submit"
          variant={variant}
        >
          {showDeliveryWindow && (
            <PdpDeliveryInfo
              deliveryDates={
                selectedSize?.processDeliveryDates || variant.masterVariant.processDeliveryDates
              }
              fulfilmentType={variant.fulfilmentType}
            />
          )}
        </AddToBagButton>
      )}
      {favoritesButton === 'button' && (
        <ProductDetailsFavoriteSection size={size} variant={variant} />
      )}
      {!inEurope && (
        <ProductDetailsFinalSaleInformation returnPolicy={activeVariant.returnPolicy} />
      )}
    </Stack>
  );
};
